import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';

const ContactCTA = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-primary-600 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-display font-bold mb-4">
          {t('contactCTA.title')}
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto">
          {t('contactCTA.subtitle')}
        </p>
        <Link to="/contact">
          <Button variant="gold" size="lg">
            {t('contactCTA.button')}
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default ContactCTA;
